import './Leadership.css';
import { useEffect } from 'react';

function Leadership({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const roles = [
    {
      role: "3rd Year Representative",
      org: "CPE-3A Class Organization",
      year: "2024 — Present",
      desc: "Serving as the official representative for the 3rd-year Computer Engineering section. Responsible for bridging communication between students and faculty, organizing class activities, and ensuring the collective concerns of the student body are addressed efficiently. Currently leading initiatives to support peer collaboration on complex engineering projects."
    }
  ];

  return (
    <div className="lead-page">
      {/* ── Header ── */}
      <header className="lead-header">
        <div className="lead-header-inner">
          <button className="lead-back-btn" onClick={onNavigateHome}>
            <span className="lead-back-arrow">&#8592;</span> Back to Portfolio
          </button>
          <nav className="lead-breadcrumb">
            <span className="lead-bc-home" onClick={onNavigateHome}>Home</span>
            <span className="lead-bc-sep">/</span>
            <span className="lead-bc-current">Leadership</span>
          </nav>
        </div>
      </header>

      {/* ── Hero Strip ── */}
      <div className="lead-hero-strip">
        <div className="lead-strip-inner">
          <p className="lead-strip-label">Involvement & Impact</p>
          <h1 className="lead-strip-name">Leadership</h1>
          <p className="lead-strip-role">Organizations and roles where I have served and led.</p>
        </div>
      </div>

      {/* ── Main Content ── */}
      <main className="lead-main">
        <div className="lead-list">
          {roles.map((item, idx) => (
            <div className="lead-card" key={idx}>
              <div className="lead-header-row">
                <div className="lead-title-group">
                  <h3 className="lead-role">{item.role}</h3>
                  <span className="lead-org">{item.org}</span>
                </div>
                <div className="lead-year-badge">{item.year}</div>
              </div>
              <div className="lead-divider"></div>
              <p className="lead-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </main>

      {/* ── Footer ── */}
      <footer className="lead-footer">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="lead-footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>
    </div>
  );
}

export default Leadership;
